import { Service, signal } from '@angular/core';

export type ChdBackend = 'dx' | 'material';

export const CHD_BACKEND_STORAGE_KEY = 'spa-manager.chd-backend';

const DEFAULT_CHD_BACKEND: ChdBackend = 'material';

export function readChdBackendPreference(): ChdBackend {
  if (typeof localStorage === 'undefined') {
    return DEFAULT_CHD_BACKEND;
  }

  try {
    const storedBackend = localStorage.getItem(CHD_BACKEND_STORAGE_KEY);
    return storedBackend === 'dx' || storedBackend === 'material' ? storedBackend : DEFAULT_CHD_BACKEND;
  } catch {
    return DEFAULT_CHD_BACKEND;
  }
}

@Service()
export class ChdBackendService {
  readonly backend = signal<ChdBackend>(readChdBackendPreference());

  setBackend(backend: ChdBackend): boolean {
    if (backend === this.backend()) {
      return false;
    }

    try {
      localStorage.setItem(CHD_BACKEND_STORAGE_KEY, backend);
    } catch {
      return false;
    }

    this.backend.set(backend);
    return true;
  }
}
